import { type AntiForgeryTokenInfo, type ViewModel } from "../ApiClients";

declare global {
  interface Window {
    initialState: ViewModel;
    epostRegex: RegExp;
    nonce: string;
  }
}

const initial = window.initialState;
export const froala = initial.froalaLicense ?? "";
export const sentry = initial.sentryId ?? undefined;
export const postHog = initial.postHogApiKey ?? undefined;
export const {
  texts,
  footer,
  personvernerklaering,
  features,
  version,
  logoUrl,
  appEnvironment,
} = initial;
export const urls = {
  lastNedUttalelse: (eksternId: string | number) =>
    initial.urls.lastNedUttalelse.replace("_eksternId_", eksternId.toString()),
  lastNedSpørsmålUttalelseVedlegg: (eksternId: string | number) =>
    initial.urls.lastNedSpørsmålUttalelseVedlegg.replace(
      "_eksternId_",
      eksternId.toString(),
    ),
  lastNedUtkastUrl: (eksternId: string | number) =>
    initial.urls.lastNedUtkastUrl.replace("_eksternId_", eksternId.toString()),
  lastNedVedlegg: (id: string | number) =>
    initial.urls.lastNedVedlegg.replace("_id_", id.toString()),
};

export const institusjonNavnLang = initial.institusjonNavnLang!;
export const institusjonNavnKort = initial.institusjonNavnKort!;
export const getAntiForgeryTokenInfo = (): AntiForgeryTokenInfo =>
  window.initialState.antiForgeryTokenInfo!;
